// Use regular expressions to check if a string contains a number
// Checks for floats and integers
export const stringContainsNumber = (str: string) => {
  const regexFloat = /[-+]?\d*\.\d+/;
  const regexInteger = /[-+]?\b\d+\b/;
  return regexFloat.test(str) || regexInteger.test(str);
};

export const getDecimalNum = (
  inputValue: string | number,
  decimalPlaces = 2
) => {
  const isNumber =
    typeof inputValue === "number" && typeof decimalPlaces === "number";
  const isNumberString =
    typeof inputValue === "string" &&
    stringContainsNumber(inputValue) &&
    typeof decimalPlaces === "number";

  if (isNumber || isNumberString) {
    return Number(inputValue).toFixed(decimalPlaces);
  } else {
    return inputValue;
  }
};

// Formats a 0-1 fraction as a percentage, e.g. 0.9 -> "90.00%". Accepts
// numeric strings too, since some stats arrive as strings (e.g. "NaN").
export const asPercentage = (
  fraction: number | string | null | undefined,
  decimalPlaces = 2
) =>
  fraction !== null && fraction !== undefined && !isNaN(Number(fraction))
    ? `${(Number(fraction) * 100).toFixed(decimalPlaces)}%`
    : "N/A";
